
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1644913436627",
    "class": "icon",
    "style": "width: 1em; height: 1em;padding-top:2px; fill: currentcolor; overflow: hidden; font-size: 18px;",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2049",
    "width": "14",
    "height": "14",
    "data-spm-anchor-id": "a313x.7781069.0.i2"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M229.1 935.8c-7.2 0-12.7-1.1-17.1-3.3-6-3-10.1-8.2-11.7-14.6-3.6-14.8 6.9-30.3 25.8-56.2 6.7-9.3 18.6-25.5 21.7-33.6C151.6 748.5 96.5 631.3 96.5 506c0-56.4 11-111 32.7-162.5 20.9-49.7 50.9-94.4 89.1-132.7 38.2-38.4 82.7-68.5 132.2-89.5 51.3-21.8 105.8-32.8 162-32.8s110.6 11 162 32.8c49.5 21 94 51.2 132.2 89.5 38.2 38.3 68.2 83 89.1 132.7 21.7 51.5 32.7 106.2 32.7 162.5s-11 111-32.7 162.5c-21 49.7-50.9 94.4-89.1 132.7-38.2 38.4-82.7 68.5-132.2 89.5-51.3 21.8-105.8 32.8-162 32.8-41.8 0-83-6.2-122.5-18.4-1-0.2-6.6-0.9-26.6 3-14.5 2.8-32.4 7.3-49.7 11.5-41.7 10.4-67.7 16.2-84.6 16.2z m160.8-30.7z m-164.4-1.5z m287-783.2c-211.7 0-384 173-384 385.6 0 117.3 52.2 226.8 143.2 300.4 7.6 6.2 14.2 18.2 2.4 40.8-5.4 10.4-14 22.1-22.2 33.4-4.7 6.4-11.4 15.6-15.8 22.8 4.2-0.4 9.9-1.3 17.6-2.8 15.4-3 34.1-7.6 52.2-12.1 49.3-12.2 77.9-18.8 93.3-14.1 36.5 11.3 74.6 17 113.2 17 211.7 0 384-173 384-385.6 0.1-212.4-172.2-385.4-383.9-385.4z",
        "p-id": "2050"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M304.5 516.255a37.1 36.9 90 1 0 73.8 0 37.1 36.9 90 1 0-73.8 0Z",
        "p-id": "2051"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M480.2 516.255a37.1 36.9 90 1 0 73.8 0 37.1 36.9 90 1 0-73.8 0Z",
        "p-id": "2052"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M655.9 516.255a37.1 36.9 90 1 0 73.8 0 37.1 36.9 90 1 0-73.8 0Z",
        "p-id": "2053"
      }
    }
  ]
})
    }
  